export default __webpack_public_path__ + "a9f739e.svg";